import { apolloClient } from '@/apolloClient';
import { GET_CURRENT_USER, GET_SCHOOL_QUERY } from '@/graphql';
import type { School, UserType } from '@/types/composition-functions';

export function useAuthApi() {
  async function fetchCurrentUser(includeTertiary: boolean): Promise<UserType> {
    const response = await apolloClient.query({
      query: GET_CURRENT_USER,
      variables: { include_tertiary: includeTertiary },
      fetchPolicy: 'network-only',
    });
    return response.data.me;
  }

  /** The school named by X-Current-School-ID (the saved current school). */
  async function fetchCurrentSchool(): Promise<School | null> {
    const response = await apolloClient.query<{ getSchool: School | null }>({
      query: GET_SCHOOL_QUERY,
      fetchPolicy: 'network-only',
    });
    return response.data?.getSchool ?? null;
  }

  async function clearApolloStore() {
    try {
      await apolloClient.clearStore();
    } catch {
      // Best-effort store clear; ignore failure.
    }
  }

  return { fetchCurrentUser, fetchCurrentSchool, clearApolloStore };
}
